import * as Long from "long";
import { from } from "rxjs";
import { IdResource } from "../../../../constants/IdResource";
import { selectAndApplyActiveBuildingBuffedCost } from "../../../../selectors/selectBuffsInfo";
import { selectBuildingUpgradeInfo } from "../../../../selectors/selectExistingBuildingInfo";
import { selectInventoryResourceInfo } from "../../../../selectors/selectInventoryInfo";
import { selectOngoingPurchaseInfoStandard } from "../../../../selectors/selectOngoingPurchaseInfo";
import { actionModalClose, actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { IdMissingResourceTypes } from "../../../not-enough-resource/IdMissingResourceTypes";
import { actionOngoingPurchaseStandardSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
export var pathBuildingUpgradeNotEnoughResourcePremium = function (action$, state$) {
    var state = state$.value;
    var upgradeInfo = selectBuildingUpgradeInfo(action$.building);
    var next = upgradeInfo.nextStage;
    var premiumCost = next.premium.cost.find(function (cost) { return cost.resourceId === IdResource.Gold; });
    var premiumAmount = selectAndApplyActiveBuildingBuffedCost(state, action$.building.balancing.id, IdResource.Gold, premiumCost.amount);
    var playerGold = selectInventoryResourceInfo(state, IdResource.Gold);
    var availableGold = playerGold.amount;
    var standardPurchase = selectOngoingPurchaseInfoStandard(state);
    var missingGoldInfo = [
        {
            amount: Long.fromValue(premiumAmount).subtract(availableGold),
            typeId: IdResource.Gold,
        },
    ];
    if (standardPurchase && standardPurchase.length > 0) {
        standardPurchase.unshift({
            missingResources: missingGoldInfo,
            missingType: IdMissingResourceTypes.Gold,
        });
        return from([
            actionOngoingPurchaseStandardSelect(standardPurchase),
            actionModalOpen(IdModal.NotEnoughResource),
        ]);
    }
    return from([
        actionOngoingPurchaseStandardSelect([
            {
                missingResources: missingGoldInfo,
                missingType: IdMissingResourceTypes.Gold,
            },
        ]),
        actionModalClose(IdModal.NotEnoughResource),
        actionModalOpen(IdModal.NotEnoughResource),
    ]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/path/pathBuildingUpgradeNotEnoughResourcePremium.ts
// module id = 2079
// module chunks = 3